'use client'
import { getDistinctVilles } from '@/app/_server/ventesPrisma'
import { Prisma } from '@prisma/client'
import { usePathname, useRouter } from 'next/navigation'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Select from 'react-select'

type Props = {
    searchParams: URLSearchParams
    regions: Prisma.RegionsGetPayload<{
        include: {
            departements: true;
        };
    }>[]
    departements: Prisma.DepartementsGetPayload<{}>[]
}

type OptionType = {
    label: string;
    value: string;
}

const FilterVentesVille = ({ regions, departements, searchParams }: Props) => {
    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams), [searchParams])
    const router = useRouter()

    const [villes, setVilles] = useState<{
        nom: string;
        departement: string;
    }[]>([])
    
    const fetchVilles = useCallback(async (search: string) => {
        let departementsToSearch: string[] = []
        if (params.has('departement')) {
            departementsToSearch = params.getAll('departement')
        } else if (params.has('region')) {
            departementsToSearch = regions.find(region => region.nom === params.get('region'))?.departements.map(departement => departement.cp) ?? []
        }else{
            departementsToSearch = departements.map(departement => departement.cp)
        }

        const result = await getDistinctVilles(search, departementsToSearch);
        setVilles(result);
    }, [params, regions, departements]);

    const [villeSelected, setVilleSelected] = useState<string|null>()

    const options = villes.map(ville => ({ label: `${ville.nom} (${ville.departement})`, value: ville.nom }));

    const handleSearchVille = (search: string) => {
        if (search.length < 1) {
            setVilles([])
            return;
        }
        
        fetchVilles(search);
    }

    const handleChange = async (selectedOption?: {
        label: string;
        value: string;
    }) => {
        
        
        params.delete('ville')
        params.set('page', '1')

        if (!selectedOption) {
            setVilleSelected(null)
            router.push(pathName + '?' + params.toString())
            return
        }
        params.delete('region')
        params.delete('departement')
        const region = regions.find(region => region.departements.find(departement => departement.cp === selectedOption.label.split('(')[1].split(')')[0]))
        if (region) {
            params.append('region', region.nom)
        }
        params.append('departement', selectedOption.label.split('(')[1].split(')')[0])
        params.append('ville', selectedOption.value)
        setVilleSelected(selectedOption.value)
        router.push(pathName + '?' + params.toString())
    };

    useEffect(() => {
        
        if (params.has('ville')) {
            if (options.length === 0) {
                fetchVilles(params.get('ville') || '')
            }
            setVilleSelected(`${params.get('ville')}`)
        } else {
        
            setVilleSelected(null)
        }
    }, [params, villeSelected, fetchVilles, options])
    
    return (
        <div className='w-full lg:w-1/3'>
            <Select
                id='select-ville'
                className="basic-single"
                placeholder="Rechercher ville"
                styles={{
                    control: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    container: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    menu: (provided: any) => ({
                        ...provided,
                        width: '100%',
                        zIndex: 600
                    }),
                }}
                options={options}
                getOptionLabel={(option: OptionType) => option.label}
                getOptionValue={(option: OptionType) => option.value}
                noOptionsMessage={() => "Aucune ville correspondante"}
                isClearable={true}
                isSearchable={true}
                onInputChange={(search: string) => handleSearchVille(search)}
                onChange={(selectedOption) => {
                    handleChange(selectedOption ?? undefined)
                }}
                value={villeSelected ? options.find(option => option.value === villeSelected) : null}
                aria-label='Filtre villes'
                filterOption={null}
            />
        </div>
    )
}

export default FilterVentesVille